import {
	editCreditCard,
	EditCreditCardPayload,
	EditCreditCardResponse,
} from "@/api/credit-cards/credit-cards";
import { MutationOptionsWithoutFn } from "@/types/types";
import { useMutation } from "@tanstack/react-query";

export default function useEditCreditCard(
	options?: MutationOptionsWithoutFn<
		EditCreditCardResponse,
		EditCreditCardPayload
	>,
) {
	return useMutation({
		mutationFn: editCreditCard,
		...options,
	});
}
